import { isEmpty } from 'lodash';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import { DraftPromptReplacements } from '../../../shared/enums';


const PROMPT_PS_DIVIDER = `<<${DraftPromptReplacements.PROMPT_PS_DIVIDER}>>`;

const replaceVariables = (prompt, variables) => prompt.replace(/<<(.*?)>>/g, (_, match) => variables[match.trim()]);

const getPromptWithVariables = (chapterData, nextChapterData, promptMessage) => {
  if (isEmpty(chapterData)) return promptMessage;
  const regexToFindNewLines = new RegExp(`\n*(${PROMPT_PS_DIVIDER})\n*`, 'g');
  const prompt = promptMessage.replace(regexToFindNewLines, '$1');
  const converter = new QuillDeltaToHtmlConverter(chapterData.descriptionDelta.ops, {});
  let chapterOverview = converter.convert();
  chapterOverview = chapterOverview.replace(/<li[^>]*>(.*?)<\/li>/g, '\u2022 $1\n');
  chapterOverview = chapterOverview.replace(/<[^>]+>/g, '\n');
  chapterOverview = chapterOverview.replace(/&#x27;/g, '\'');

  let [promptStart = '', promptEnding = ''] = prompt.split(PROMPT_PS_DIVIDER);
  const variablesReplacements = {
    [DraftPromptReplacements.NEXT_CHAPTER_TITLE]: nextChapterData.title,
    [DraftPromptReplacements.NEXT_CHAPTER_NUMBER]: nextChapterData.sequenceNumber,
    [DraftPromptReplacements.CHAPTER_TITLE]: chapterData.title,
    [DraftPromptReplacements.CHAPTER_NUMBER]: chapterData.sequenceNumber,
    [DraftPromptReplacements.CHAPTER_OVERVIEW]: chapterOverview,
  };

  promptStart = replaceVariables(promptStart, variablesReplacements);

  if (isEmpty(nextChapterData)) {
    promptEnding = '';
  } else {
    promptEnding = replaceVariables(promptEnding, variablesReplacements);
  }

  return promptStart + promptEnding;
};

export default getPromptWithVariables;
